import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './services/store/store';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';


const Init = () => {
  const [isReady, setIsReady] = useState(process.env.NODE_ENV !== 'development');

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      import('./mocks/browser')
        .then(({ worker }) => worker.start({
          onUnhandledRequest(request, print) {
            const url = new URL(request.url);
            const excludedRoutes = [
              'hotjar.com',
              'youtube.com',
              'hot-update',
              'app.min.js',
              'manifest.json',
              'hotjar-560365.js',
              '/log/',
              '/rum/intake/v2/rum/events',
              'content/injected',
              '/static/media/',
            ];
            const isExcluded = excludedRoutes.some(route =>
              url.origin.includes(route) ||
              url.pathname.includes(route) ||
              url.pathname.endsWith('.png')
            );
            if (isExcluded) {
              return;
            }
            print.warning();
          },
          serviceWorker: {
            url: '/mockServiceWorker.js'
          }
        }))
        .then(() => setIsReady(true))
        .catch(err => {
          console.error('Failed to start the worker:', err);
          setIsReady(true); // or handle the error state differently
        });
    }
  }, []);

  if (!isReady) {
    return <div>Loading...</div>; // Placeholder for loading state
  }


  return (
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<Init />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
